import React from 'react';

import { makeStyles
} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({

    buttonDisabled: {
        color:  "rgba(0, 0, 0, 0.26)",
        border: "1px solid rgba(0, 0, 0, 0.12)"
    },
    menuItemDisabledSemFormulario: {
        color:  "rgba(0, 0, 0, 0.26)",
      },
    }));

export default useStyles;
